import { useMemo } from 'react'

const CHART_MODE_OPTIONS = {
  pie: { message: 'Pie Chart', icon: 'pie-chart-v2' },
  respondents: { message: 'Column Chart', icon: 'columns-chart-v2' },
  percents: { message: 'Percent Column Chart', icon: 'stacked-columns-chart-v2' },
  brespondents: { message: 'Bar Chart', icon: 'bars-chart-v2' },
  bpercents: { message: 'Percent Bar Chart', icon: 'stacked-bars-chart-v2' }
}

const FALLBACK_ICON = 'columns-chart-v2'

export const useChartModeOptions = ({
  chartModeTypes,
  chartModeOptions = CHART_MODE_OPTIONS,
  withDefault = true,
  chartMode,
  chartModeOverride,
  globalChartMode
}) => {
  // A question with no override of its own follows the report, whatever that resolves to here.
  const followsReport = !chartModeTypes.includes(chartModeOverride)

  // What picking Default resolves to: while the question follows the report, exactly what is drawn;
  // once overridden, the report-wide mode where this question offers it and the first mode it does
  // offer otherwise -- the same modes the legacy pie -> respondents / -> percents coercions produced.
  const fallbackChartMode = chartModeTypes.includes(globalChartMode) ? globalChartMode : chartModeTypes[0]
  const defaultChartMode = followsReport ? chartMode : fallbackChartMode
  const defaultIcon = chartModeOptions[defaultChartMode]?.icon || FALLBACK_ICON

  // the closed selector wears what is drawn now: the explicit pick, or the default it falls back to
  const currentIcon = chartModeOptions[chartMode]?.icon || defaultIcon

  // Default is what following the report means, so it stays highlighted until the question is
  // overridden; a selector without that row has nothing else to name but the drawn mode.
  const selectedChartMode = followsReport ? (withDefault ? 'off' : chartMode) : chartModeOverride

  const options = useMemo(() => {
    const defaultOption = withDefault ? [{ key: 'off', text: 'Default', icon: defaultIcon }] : []

    const modeOptions = chartModeTypes
      .filter(mode => chartModeOptions[mode])
      .map(mode => ({
        key: mode,
        text: chartModeOptions[mode].message,
        icon: chartModeOptions[mode].icon
      }))

    return [...defaultOption, ...modeOptions]
  }, [chartModeTypes, chartModeOptions, withDefault, defaultIcon])

  return { options, currentIcon, selectedChartMode }
}
